import React,{useState} from 'react';
import {BrowserRouter as Router,Route,Switch} from 'react-router-dom';
import Window from './window';
import './styles/App.scss';
import Start from './Start';
import TimesUp from './Timesup';


const App = () => {

  const [correct,setCorrect] = useState(0);

    return ( 
      <Router>
          <div className="main">
          
          <Switch>
            <Route exact path = "/">
              <Start/>
            </Route>
            <Route exact path = "/window">
              <Window correct={correct} setCorrect={setCorrect}/>
            </Route>
            <Route exact path = "/Timesup">
              <TimesUp correct={correct}/>
            </Route>
          </Switch>
          
          </div>
      </Router>
     );
}
 
export default App;